<template>
  <div class="attendance-manage">
    <Modal
      v-model="settingsShow"
      width="800"
      :mask-closable="false"
      title="考勤规则设置">
      <Form :model="settingsForm">
        <div class="settingsFormItem" style="padding: 20px;">
          <h3 style="margin-bottom: 10px;">考勤时间设置</h3>
          <FormItem style="margin-bottom: 5px;">
            <RadioGroup v-model="settingsForm.defaultFlag" vertical @on-change="onRadioChange('defaultFlag')">
              <Radio label="0">
                  <span>使用默认时间（上班时间：9:00，下班时间：18:00）</span>
              </Radio>
              <Radio label="1">
                  <span>自定义时间</span>
              </Radio>
            </RadioGroup>
          </FormItem>

          <FormItem v-if=" settingsForm.defaultFlag == '1'">
            <RadioGroup v-model="settingsForm.unifyFlag" style="margin-left: 50px;" @on-change="onRadioChange('unifyFlag')">
              <Radio label="0" style="margin-right: 50px;">
                  <span>全年统一考勤</span>
              </Radio>
              <Radio label="1">
                  <span>按节季时间考勤</span>
              </Radio>
            </RadioGroup>
          </FormItem>

          <FormItem v-if="settingsForm.unifyFlag == '0'">
            <div style="display: flex;margin: 0 0 10px 50px;">
              <h3 style="margin-right: 10px;">上班时间</h3>
              <TimePicker type="time" v-model="settingsForm.startWork" placeholder="请设置上班时间" style="margin-right: 10px;"></TimePicker>
            </div>
            <div style="margin-left: 50px;display: flex;">
              <h3 style="margin-right: 10px;">下班时间</h3>
              <TimePicker type="time" v-model="settingsForm.offWork" placeholder="请设置下班时间" style="margin-right: 10px;"></TimePicker>
            </div>
          </FormItem>

          <FormItem v-if="settingsForm.unifyFlag == '1'">
            <div style="display: flex;">
              <div style="margin-left: 50px;">
                <div style="display: flex;margin-bottom: 10px;">
                  <h3 style="margin-right: 10px;width: 60px;">夏季</h3>
                  <DatePicker type="month" v-model="settingsForm.summerDateStart" format="MM月" placeholder="请选择月份" style="margin-right: 10px;"></DatePicker>
                </div>
                <div style="display: flex;margin-bottom: 10px;">
                  <h3 style="margin-right: 10px;width: 60px;">上班时间</h3>
                  <TimePicker type="time" v-model="settingsForm.summerStartWork" placeholder="请设置上班时间" style="margin-right: 10px;"></TimePicker>
                </div>
                <div style="display: flex;margin-bottom: 10px;">
                  <h3 style="margin-right: 10px;width: 60px;">下班时间</h3>
                  <TimePicker type="time" v-model="settingsForm.summerOffWork" placeholder="请设置下班时间" style="margin-right: 10px;"></TimePicker>
                </div>
              </div>
              <div style="margin-left: 50px;">
                <div style="display: flex;margin-bottom: 10px;">
                  <h3 style="margin-right: 10px;width: 60px;">冬季</h3>
                  <DatePicker type="month" v-model="settingsForm.winterDateStart" format="MM月" placeholder="请选择月份" style="margin-right: 10px;"></DatePicker>
                </div>
                <div style="display: flex;margin-bottom: 10px;">
                  <h3 style="margin-right: 10px;width: 60px;">上班时间</h3>
                  <TimePicker type="time" v-model="settingsForm.winterStartWork" placeholder="请设置上班时间" style="margin-right: 10px;"></TimePicker>
                </div>
                <div style="display: flex;margin-bottom: 10px;">
                  <h3 style="margin-right: 10px;width: 60px;">下班时间</h3>
                  <TimePicker type="time" v-model="settingsForm.winterOffWork" placeholder="请设置下班时间" style="margin-right: 10px;"></TimePicker>
                </div>
              </div>
            </div>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button @click="handleCancel">取消</Button>
        <Button type="primary" @click="handleSave">确定</Button>
      </div>
    </Modal>
    <div class="filter-form">
      <div class="left">
        考勤时间：<DatePicker type="daterange" v-model="filterData.time" style="margin-right: 10px;"></DatePicker>
        所在部门：
        <Select style="width: 150px;margin-right: 10px;" v-model="filterData.departmentId" @keydown.enter.native="handleSearch">
          <Option v-for="item in departmentList" :value="item.id" :key="item.id">{{item.name}}</Option>
        </Select>
        <div class="user-name">
          <span>员工姓名：</span>
          <i-input @keydown.enter.native="handleSearch" v-model="filterData.userName" style="width: 200px" >
            <Select v-model="filterData.status" slot="prepend" style="width: 80px">
              <Option value="1">在职员工</Option>
              <Option value="0">离职员工</Option>
            </Select>
          </i-input>
        </div>
        <Button @click="handleSearch" type="primary" style="margin-left: 15px">查询</Button>
        <Button @click="handleClearForm" style="margin-left: 5px">重置</Button>
      </div>
      <div class="exportButton">
        <h3>员工列表</h3>
        <div>
          <Button @click="settings" style="margin-right: 20px;">考勤设置</Button>
          <Button @click="companyExport" :loading="downloadLoading"  size="default" customIcon="iconfont icon-xiazai">导出</Button>
        </div>
      </div>
    </div>
    <div class="table-data">
      <Table :columns="staffColumn" :data="staffList" :loading="loading"></Table>
      <div class="page">
        <Page :total="total" :current="filterData.page" :page-size="filterData.rows" @on-change="pageChange"></Page>
      </div>
    </div>
  </div>
</template>

<script type="text/jsx">
  import axios from 'axios';
  import moment from 'moment';
  export default {
    name: 'Attendance',
    data () {
      return {
        settingsShow: false,
        settingsForm: {
          memberId: sessionStorage.getItem('companyId'),
          defaultFlag: '0',
          summerDateStart: '',
          summerOffWork: '',
          summerStartWork: '',
          unifyFlag: '',
          winterDateStart: '',
          winterOffWork: '',
          winterStartWork: '',
          startWork: '',
          offWork: ''
        },
        filterData: {
          userName: '',
          departmentId: '',
          status: '1',
          time: [
            new Date(new Date().getFullYear(), new Date().getMonth(), 1),
            new Date(new Date().toLocaleDateString())
          ],
          page: 1,
          rows: 30
        },
        total: null,
        departmentList: [],
        colorType: {
          0: '',
          1: 'Holiday',
          2: '',
          3: 'RestDay'
        },
        staffColumn: [
          {
            title: '姓名',
            key: 'userName',
            align: 'center'
          },
          {
            title: '手机号',
            key: 'mobile',
            align: 'center'
          },
          {
            title: '部门',
            key: 'departmentName',
            align: 'center'
          },
          {
            title: '日期',
            key: 'date',
            width: 150,
            align: 'center'
          },
          {
            title: '是否工作日',
            align: 'center',
            render: (h, params) => {
              return (
                <div>
                  <span class={this.colorType[params.row.dayType]}>{params.row.dayTypeName}</span>
                </div>
              )
            }
          },
          {
            title: '上班打卡',
            key: 'earlyTime',
            align: 'center',
            render: (h, params) => {
              return (
                <div>
                  <span class={this.colorType[params.row.dayType]}>{params.row.earlyTime || '--'}</span>
                </div>
              )
            }
          },
          {
            title: '下班打卡',
            key: 'lateTime',
            align: 'center',
            render: (h, params) => {
              return (
                <div>
                  <span class={this.colorType[params.row.dayType]}>{params.row.lateTime || '--'}</span>
                </div>
              )
            }
          },
          {
            title: '工作时长',
            align: 'center',
            render: (h, params) => {
              return (
                <div>
                  <span class={this.colorType[params.row.dayType]}>{params.row.workTimes || '--'}</span>
                </div>
              )
            }
          }
        ],
        staffList: [],
        loading: false,
        downloadLoading: false
      }
    },
    mounted () {
      this.initialData();
    },
    methods: {
      initialData () {
        this.fetchDepartment();
        this.updateStaff();
      },
      fetchDepartment () {
        this.$get(`/department`).then(res => {
          if (res.success) {
            this.departmentList = res.data;
          }
        })
      },
      updateStaff () {
        this.loading = true;
        let startTime = moment(this.filterData.time[0]).format('YYYY-MM-DD');
        let endTime = moment(this.filterData.time[1]).format('YYYY-MM-DD');
        let { userName, departmentId, status, page, rows } = this.filterData;
        let options = { userName, departmentId, status, page, startTime, endTime, rows };
        this.$get(`/company/door/list`, options).then(res => {
          if (res.success) {
            this.staffList = res.data.list;
            this.filterData.page = res.data.pageNum;
            this.total = res.data.total;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
      },
      handleClearForm () {
        this.filterData.userName = '';
        this.filterData.departmentId = '';
        this.filterData.page = 1;
        this.filterData.time = [
          new Date(new Date().getFullYear(), new Date().getMonth(), 1),
          new Date(new Date().toLocaleDateString())
        ];
        this.updateStaff();
      },
      handleSearch () {
        this.filterData.page = 1;
        this.updateStaff();
      },
      pageChange (e) {
        this.filterData.page = e;
        this.updateStaff();
      },
      settings () {
        this.settingsShow = true
        this.$post(`/customer/attendance/setupInfo/${sessionStorage.getItem('companyId')}`).then(res => {
          if (res.success) {
            console.log(res)
            this.settingsForm = res.data
            this.settingsForm.memberId = sessionStorage.getItem('companyId')
            this.settingsForm.summerDateStart = String(res.data.summerDateStart)
            this.settingsForm.winterDateStart = String(res.data.winterDateStart)
          }
        })
      },
      handleCancel () {
        this.settingsShow = false
      },
      onRadioChange (e) {
        console.log(e)
        this.settingsForm.offWork = '';
        this.settingsForm.startWork = '';
        this.settingsForm.summerDateStart = '';
        this.settingsForm.summerOffWork = '';
        this.settingsForm.summerStartWork = '';
        this.settingsForm.winterDateStart = '';
        this.settingsForm.winterOffWork = '';
        this.settingsForm.winterStartWork = '';
        if (e === 'defaultFlag') {
          this.settingsForm.unifyFlag = '';
        }
      },
      handleSave () {
        this.settingsForm.summerDateStart = this.settingsForm.summerDateStart === '' ? null : moment(this.settingsForm.summerDateStart).format('MM')
        this.settingsForm.winterDateStart = this.settingsForm.winterDateStart === '' ? null : moment(this.settingsForm.winterDateStart).format('MM')
        console.log(this.settingsForm)
        this.$post(`/customer/attendance/setup`, this.settingsForm).then(res => {
          if (res.success) {
            console.log(res)
            this.settingsShow = false
            this.$Message.success('保存成功')
          }
        })
      },
      companyExport () {
        let that = this;
        this.downloadLoading = true;
        let startTime = moment(this.filterData.time[0]).format('YYYY-MM-DD');
        let endTime = moment(this.filterData.time[1]).format('YYYY-MM-DD');
        let { userName, departmentId, status, page, rows } = this.filterData;
        let options = { userName, departmentId, status, page, startTime, endTime, rows };
        this.$get(`/company/export`, options, true, 'blob').then(res => {
          let blob = res.data;
          if (blob.type === 'application/json') { // 异常
            let read = new FileReader();
            read.onload = function (e) {
              that.$Message.config({
                top: 72
              });
              that.$Message.error({
                content: JSON.parse(e.target.result).msg,
                duration: 5,
                closable: true
              });
              that.downloadLoading = false;
            };
            read.readAsText(blob);
          } else { // 正常数据流
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onload = (e) => {
              const a = document.createElement('a');
              a.download = decodeURI(res.headers.filename);
              a.href = e.target.result;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              this.$Message.success('导出成功');
              this.downloadLoading = false;
            };
          }
        })
      }
    }
  }
</script>

<style lang="less">
.RestDay{
  color: #d7d7d7;
}
.Holiday{
  color: #FF592F;
}
  .attendance-manage {
    padding: 20px;
    .filter-form {
      .ivu-date-picker-rel {
        width: 200px;
      }
      .user-name {
        display: -webkit-inline-box;
        .ivu-input-group {
          top: -6px;
        }
      }
      .exportButton{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        h3 {
          font-size: 16px;
        }
        i {
          font-size: 14px;
          font-weight: 600;
        }
      }
    }
    .table-data{
      padding-top: 10px;
      .ivu-dropdown-menu{
        li{
          text-align: center;
          padding: 5px;
          cursor: pointer;
          &:hover{
            background: #f3f3f3;
          }
        }
      }
      .avatar{
        display: inline-block;
        border-radius: 50%;
        &.admin{
          background-color: #fd996b;
        }
        &.subAdmin{
          background-color: #3cb035;
        }
        width: 20px;
        height: 20px;
        line-height: 20px;
        color: #ffffff;
        text-align: center;
        margin-right: 5px;
      }
    }
    .page{
      margin-top: 50px;
      .ivu-page{
        text-align: center;
      }
    }
  }
</style>
